import { render, staticRenderFns } from "./ModalPaymentCategoriesDoctor.vue?vue&type=template&id=23650600"
import script from "./ModalPaymentCategoriesDoctor.vue?vue&type=script&lang=js"
export * from "./ModalPaymentCategoriesDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports